import React from "react";
import { Link } from "react-router-dom";
import "../CheckableButton/CheckableButton.css";
import { notify } from "react-notify-toast";

import "./MakeABooking.css";

function MakeABooking() {
  return (
    <div className="makeabookingcontainer">
      <Link
        className="makeabooking"
        id="makeabooking"
        title="Booking"
        to="/CollegeCalendar"
        onClick={() => notify.show("Click on the date you would like to make a booking in the calendar below.")}
      >
        Book Now
      </Link>
    </div>
  );
}

export default MakeABooking;
